import { POINTS_NAME } from "~/constants"

export function PointsIcon() {
	switch (POINTS_NAME) {
		case "tickets":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="20"
					height="20"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
					className="lucide lucide-ticket-icon lucide-ticket"
				>
					<path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
					<path d="M13 5v2" />
					<path d="M13 17v2" />
					<path d="M13 11v2" />
				</svg>
			)
		case "points":
		default:
			return <PointsIcon />
	}
}
